import { SActionBtn, SIDRender, SLowcodeList, SMessage, STableActions } from 'shj-components'
import config from './config'
import { useEffect, useRef, useState } from 'react'
import { apiData2Table } from '@/utils/data'
import NewOrEditCustomer from './modalsOrDrawers/newOrEditCustomer'
import { useNavigate } from 'react-router-dom'
import CheckThePhone from '@/components/CheckThePhone'
import { httpOrgList } from '@/services/homeService'
import { getAuth } from '@/utils/auth'
import { Button, message } from 'antd'
import { deleteCustomer, getCustomerList } from '@/services/customerManage'
import UrlConfig from '@/api/UrlConfigs'
import { KeepAlive } from 'react-activation'

const CustomerProfile = () => {
  const auth = getAuth()
  const listRef = useRef<any>()
  const navigate = useNavigate()
  const [open, setOpen] = useState(false)
  const [openWay, setOpenWay] = useState<'add' | 'edit' | 'detailEdit'>('add')
  const [editRecord, setEditRecord] = useState<Record<string, any>>({})

  // 获取列表数据
  const fetchList = async (params: any) => {
    return new Promise((resolve, reject) => {
      try {
        const request = {
          params: {
            pageId: params.current,
            pageSize: params.pageSize,
          },
          data: {
            nameLike: params.query.nameLike,
            id: params.query.id,
            phone: params.query.phone,
            storeIds: params.query.storeIds ? [params.query.storeIds] : undefined,
            pin: params.query.pin,
            orderBys: [{ columnName: 'createdTime', asc: false }],
          },
        }
        getCustomerList(request).then((res: any) => {
          resolve(apiData2Table(res))
        })
      } catch (error) {
        reject({ success: false })
      }
    })
  }

  // 获取适用门店
  const getOrgList = () => {
    return new Promise((resolve, reject) => {
      try {
        httpOrgList().then((res: any) => {
          resolve({ companyList: res })
        })
      } catch (error) {
        reject({ success: false })
      }
    })
  }

  // 新增
  const addConfig = () => {
    setOpen(true)
    setOpenWay('add')
  }

  // 编辑
  const editConfig = (record: Record<string, any>) => {
    setOpen(true)
    setOpenWay('edit')
    setEditRecord(record)
  }

  // 删除
  const delConfig = (record: Record<string, any>) => {
    SMessage.confirm({
      title: '提示',
      content: '确定删除该客户吗？',
      onOk: () => {
        try {
          deleteCustomer({ id: record.id }).then(() => {
            message.success('删除成功')
            listRef.current?.reload()
          })
        } catch (error) {
          message.error('删除失败')
        }
      },
    })
  }

  useEffect(() => {
    getOrgList()
  }, [])

  const extension = {
    request: { fetchList, getOrgList },
    events: { addConfig },
    customRender: {
      // 操作按钮渲染
      actionTool(_, record: Record<string, any>) {
        return (
          <STableActions>
            {auth['editCustomerBtn'] && (
              <SActionBtn onClick={() => editConfig(record)}>编辑</SActionBtn>
            )}
            {auth['deleteCustomerBtn'] && (
              <SActionBtn danger onClick={() => delConfig(record)}>
                删除
              </SActionBtn>
            )}
          </STableActions>
        )
      },
      // 客户编码渲染
      numberRender(text: any, record: Record<string, any>) {
        return (
          <SIDRender
            id={text}
            onClick={() => {
              if (auth['visitCustomerInfoBtn']) {
                navigate(`/CrmPlus/customerProfileDetail/${record.id}`)
              } else {
                message.warning('您没有权限访问客户详情')
              }
            }}
          />
        )
      },
      // 手机号渲染
      checkPhoneRender(text: any, record: Record<string, any>) {
        return (
          <CheckThePhone
            url={UrlConfig.crmManageWeb.viewPhone + '/' + record.id + '/' + 'customerViewPhone'}
            initValue={text}
            auth="customerViewPhone"
            type={'GET'}
          />
        )
      },
      // 新建客户按钮
      createCustomer() {
        return auth['addCustomerBtn'] ? (
          <Button type="primary" onClick={addConfig}>
            新建客户
          </Button>
        ) : null
      },
      // 所属门店渲染
      orgNamesRender(_, record: Record<string, any>) {
        return record?.orgNames?.length > 0 ? record?.orgNames.join('；') : '-'
      },
    },
  }

  return (
    <KeepAlive name={location.pathname} id={location.pathname}>
      <div style={{ width: '100%' }}>
        <SLowcodeList searchMode={'group'} config={config} ref={listRef} {...extension} />
      </div>
      <NewOrEditCustomer
        open={open}
        onCancel={() => setOpen(false)}
        openWay={openWay}
        id={editRecord?.id}
        listRef={listRef}
      />
    </KeepAlive>
  )
}

export default CustomerProfile
